import { createContext } from 'react';

export const RaceContext = createContext({});
export const PageContentContext = createContext({});
